<div class="teacher-timer-setup" #mainEl>
  <div class="teacher-timer-setup__hint">
    <brt-pulse-circle></brt-pulse-circle>
    <span>Hier kannst du die laufende Game Session verlängern oder beenden</span>
  </div>

  <div class="teacher-timer-setup__input-wrapper">
    <div class="teacher-timer-setup__input-background">
      <div class="teacher-timer-setup__number">
        <span>88</span>
      </div>
      <div class="teacher-timer-setup__separator">:</div>
      <div class="teacher-timer-setup__number">
        <span>88</span>
      </div>
    </div>
    <div class="teacher-timer-setup__input-foreground">
      <div class="teacher-timer-setup__number">
        <span>{{currentMinutes|leadingZero:2}}</span>
      </div>
      <div class="teacher-timer-setup__separator">:</div>
      <div class="teacher-timer-setup__number">
        <span>{{currentSeconds|leadingZero:2}}</span>
      </div>
    </div>
  </div>

  <div class="teacher-timer-setup__action-button" (click)="extendGameSession()">
    + 5 Min.
  </div>
</div>

